export default "__VITE_ASSET__CkgghBE1__"